import React, { createContext, useEffect, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
  products: [],
  cart: [],
  adminToken: localStorage.getItem('adminToken') || '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS':
      return { ...state, products: action.payload };
    case 'SET_CART':
      return { ...state, cart: action.payload };
    case 'SET_TOKEN':
      return { ...state, adminToken: action.payload };
    default:
      return state;
  }
};

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    localStorage.setItem('adminToken', state.adminToken);
  }, [state.adminToken]);

  useEffect(() => {
    const savedCart = localStorage.getItem('akCrackersCart');
    if (savedCart) {
      dispatch({ type: 'SET_CART', payload: JSON.parse(savedCart) });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('akCrackersCart', JSON.stringify(state.cart));
  }, [state.cart]);

  const updateQuantity = (product, quantity) => {
    const nextCart = [...state.cart];
    const index = nextCart.findIndex(item => item.productId === product._id);
    if (quantity <= 0) {
      if (index !== -1) nextCart.splice(index, 1);
    } else {
      const subtotal = quantity * product.offerPrice;
      if (index === -1) {
        nextCart.push({ productId: product._id, name: product.name, pack: product.pack, offerPrice: product.offerPrice, quantity, imageUrl: product.imageUrl, subtotal });
      } else {
        nextCart[index] = { ...nextCart[index], quantity, subtotal };
      }
    }
    dispatch({ type: 'SET_CART', payload: nextCart });
  };

  const totalAmount = state.cart.reduce((sum, item) => sum + item.subtotal, 0);
  const totalCount = state.cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <AppContext.Provider value={{ ...state, dispatch, updateQuantity, totalAmount, totalCount }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
